parseInputValueDef